import * as React from 'react';
import { useCallback, useState } from 'react';
import { Stack, TextField } from '@mui/material';
import AppBarPage from '../components/AppBarPage';
import { useTwilioCall } from '../hooks/useTwilio';
import { Location, useLocation } from 'react-router';
import { ContactProps } from '../components/ContactForm';
import PhoneCallDialog from '../components/CallDialog';
import ModeButton from '../components/ModeButton';
import { HeadsetMic, PhoneEnabled } from '@mui/icons-material';
import usePhoneCall from '../hooks/usePhoneCall';

const OutreachPage = (): JSX.Element => {
    const loc: Location<ContactProps | undefined> = useLocation();
    const { dial, hangup, status } = usePhoneCall();
    const { dial: webDial, hangup: webHangup, status: webStatus } = useTwilioCall(
        (loc.state && {
            user_name: `${loc.state.firstName} ${loc.state.lastName}`,
            company_name: loc.state.orgName || '',
            plan_name: loc.state.planName || '',
            service_type: loc.state.serviceType || ''
        }) || {}
    );
    const [phone, setPhone] = useState('');

    const onWebClick = useCallback(() => {
        webDial(phone);
    }, [webDial, phone]);

    const onPhoneClick = useCallback(() => {
        dial(phone,
            (loc.state && {
                user_name: `${loc.state.firstName} ${loc.state.lastName}`,
                company_name: loc.state.orgName || '',
                plan_name: loc.state.planName || '',
                service_type: loc.state.serviceType || ''
            }) || {}
        );
    }, [dial, loc, phone]);

    const onHangupClick = useCallback(() => {
        if (webStatus !== '') {
            webHangup();
        }
        if (status !== '') {
            hangup()
        }
    }, [hangup, status, webHangup, webStatus]);

    const onPhoneChange = useCallback((event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setPhone(event.target.value);
    }, []);

    return (
        <AppBarPage title={'Outreach Call to ' + loc.state?.firstName}>
            <Stack direction='column' spacing={2} sx={{ maxWidth: '480px', margin: '16px auto 0' }}>
                <Stack direction='column' spacing={2} sx={{ maxWidth: '480px', margin: '16px auto 0' }}>
                    <ModeButton
                        onClick={onPhoneClick}
                        title='Phone/SIP' icon={<PhoneEnabled />} description='Our bot will call to you phone or SIP'
                        disabled={phone.length === 0 || webStatus !== ''}
                    />
                    <ModeButton
                        onClick={onWebClick}
                        title='Web' icon={<HeadsetMic />} description='Use web-based call'
                        disabled={status !== ''}
                    />
                </Stack>
                <TextField
                    name='phone'
                    label='Phone Number or SIP name'
                    placeholder='+12345678901/username'
                    value={phone}
                    onChange={onPhoneChange}
                />
                <PhoneCallDialog
                    open={status !== '' || webStatus !== ''}
                    onClose={onHangupClick}
                    title='Calling...' text={status || webStatus} />
            </Stack>
        </AppBarPage>
    )
}
export default OutreachPage;